import * as React from 'react';
import { UserContext } from 'SharedDirectory/contexts';

export const useCurrentUser = () => {
  // hook into user context
  return React.useContext(UserContext);
};

export default useCurrentUser;
